import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";

const usePause = () => {
  const playerRef = useRef(null);
  const { ref, inView } = useInView();

  useEffect(() => {
    const playing =
      playerRef?.current?.hasStarted?.() ||
      playerRef?.current?.player?.isPlaying;

    if (playing && !inView) {
      const internalPlayer =
        playerRef?.current?.getInternalPlayer?.() || playerRef?.current;

      internalPlayer?.pause?.();
      internalPlayer?.pauseVideo?.();
    }
  }, [inView]);

  return { playerRef, ref, inView };
};

export default usePause;
